import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const resetClaim = claimId =>
  call(websocketFetch, 'reset_claim', { claim_id: claimId });
